import script from "./detail.vue?vue&type=script&lang=ts&setup=true"
export * from "./detail.vue?vue&type=script&lang=ts&setup=true"

import "./detail.vue?vue&type=style&index=0&id=ed2790f0&scoped=true&lang=less"

import exportComponent from "E:\\Project\\health-force-aia-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed2790f0"]])

export default __exports__